import React from "react";
import {useTranslation} from "react-i18next";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import {COLORS} from "../../../../../../../../../../../config/constants";

type Props = {
    isActive: boolean
    disabled?: boolean
    onChange(): void
}

const CertificationCodeNotFound = ({isActive, disabled = false, onChange} : Props) => {

  const { t } = useTranslation()

  return <FormControlLabel
    checked={isActive}
    disabled={disabled}
    onChange={disabled ? undefined : onChange}
    sx={{
      '.MuiFormControlLabel-label': {
        lineHeight: 1.6,
      },
      width: '100%',
      margin: '24px 0 0',
      paddingBottom: '24px',
      borderBottom: `1px solid ${COLORS.SLIGHTLY_GRAY}`,
    }}
    control={<Checkbox sx={{
      padding: '1px 8px 0 1px',
    }}/>}
    label={t('dictionaries__text__certification__myProductIsNotInTheDescription')}
  />
}

export default CertificationCodeNotFound
